import { render, staticRenderFns } from "./ProjectPermissionList.vue?vue&type=template&id=5bfdaf27&"
import script from "./ProjectPermissionList.vue?vue&type=script&lang=js&"
export * from "./ProjectPermissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports